import type { StylesConfig } from "react-select";

export const USER_FORM_MODAL_BODY_CLASS = "user-form-modal-open";
export const USER_FORM_MODAL_DROPDOWN_Z_INDEX = 10000;

export const userFormModalDropdownStyles: StylesConfig<
  { label: string; value: string | number },
  false
> = {
  menuPortal: (base) => ({
    ...base,
    zIndex: USER_FORM_MODAL_DROPDOWN_Z_INDEX,
  }),
  menu: (base) => ({
    ...base,
    zIndex: USER_FORM_MODAL_DROPDOWN_Z_INDEX + 1,
  }),
};

export const getUserFormDropdownMenuProps = () => ({
  menuPortalTarget: document.body,
  styles: userFormModalDropdownStyles,
  autoComplete: "off",
});
